import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const getProducts = () => {
  return axios.get(`${API_URL}/products/`);
};
const getProduct = (id) => {
  return axios.get(`${API_URL}/products/find/${id}`);
};
const getProductWithCatId = (id) => {
  return axios.get(`${API_URL}/products/catId/${id}`);
};

export { getProducts, getProduct, getProductWithCatId };
